import {createStore} from 'redux';
import {persistStore, persistReducer} from "redux-persist";
import storage from "redux-persist/lib/storage"

const init_state = { session: {
    id: null,
    managing_professor: null,
    name: null,
    phone: null,
    role: null,
    student_number: null,
  },
  token: null,
  refreshToken: null,
};

const reducer = (state, action) => {
  if(action.type === 'SET_TOKEN'){
    return {...state, token: action.token}
  }
  if(action.type === 'SET_SESSION'){
    return {...state, session: action.session}
  }
  if(action.type === 'SET_COGNITO_TOKENS'){
    return {
      ...state,
      token: action.idToken,
      refreshToken: action.refreshToken,
    }
  }
  if(action.type === 'RESET'){
    return init_state
  }
  return state;
}

const persistConfig = {
  key: "root",
  storage
};

const persistedReducer = persistReducer(persistConfig, reducer);

export const store = createStore(persistedReducer, init_state, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())
export const persistor = persistStore(store)
